import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { EstateUtils } from '../../utils'

import { colors, ACL } from '../../constants'

const ProfileMenu = styled.div`
    background: ${colors.bluelight};
    box-shadow: 0 1px 2px #0000006c;
    color: ${colors.white};
    position: absolute;
    text-align: left;
    transform-origin: top;
    transform: scaleY(0);
    transition: all 0.3s ease;
    right: 0px;
    width: 300px;
    z-index: 500;

    ${({ open }) =>
        open &&
        `
    height: fit-content;
    transform: scaleY(1);
  `}
`

const Item = styled.div`
    line-height: 40px;
    overflow: hidden;
    padding: 0 20px;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${({ onClick }) =>
        onClick
            ? `
        cursor: pointer;
        &:active, &:focus, &:hover {
          background: ${colors.bluelighter};
          color: ${colors.blue};
        }
      `
            : 'cursor: default;'}
`

const Icon = styled.div`
    display: inline-block;
    width: 30px;
`

const Label = styled.div`
    display: inline-block;
`

const Menu = ({
    app,
    hideLogout,
    onBlur,
    onClickChangeLanguage,
    onClickConfigureDevice,
    onClickLogout,
    onClickNavigateLog,
    onClickNavigateReports,
    onClickNavigateOperationsHub,
    open,
    t,
    username,
}) => (
    <ProfileMenu onBlur={onBlur} open={open}>
        {username && (
            <Fragment>
                <Item>
                    <Icon>
                        <FontAwesomeIcon icon="user" />
                    </Icon>
                    <Label>{username}</Label>
                </Item>
            </Fragment>
        )}
        {EstateUtils.hasPermission({ app }, { acls: [ACL.VIEW_LOGS] }) && (
            <Item onClick={onClickNavigateLog}>
                <Icon>
                    <FontAwesomeIcon icon="bolt" />
                </Icon>
                <Label>{t('Logs')}</Label>
            </Item>
        )}
        {EstateUtils.hasPermission({ app }, { acls: [ACL.VIEW_CONFIGURE] }) && (
            <Item onClick={onClickConfigureDevice}>
                <Icon>
                    <FontAwesomeIcon icon="desktop" />
                </Icon>
                <Label>{t('configure-device', { id: '' })}</Label>
            </Item>
        )}
        <Item onClick={onClickNavigateOperationsHub}>
            <Icon>
                <FontAwesomeIcon icon="cogs" />
            </Icon>
            <Label>{t('Operations Hub')}</Label>
        </Item>
        <Item onClick={onClickChangeLanguage}>
            <Icon>
                <FontAwesomeIcon icon="language" />
            </Icon>
            <Label>{t('Change Language')}</Label>
        </Item>
        {!hideLogout && (
            <Item onClick={onClickLogout}>
                <Icon>
                    <FontAwesomeIcon icon="sign-out-alt" />
                </Icon>
                <Label>{t('Logout')}</Label>
            </Item>
        )}
    </ProfileMenu>
)

Menu.propTypes = {
    app: PropTypes.shape({}),
    hideLogout: PropTypes.bool,
    onBlur: PropTypes.func,
    onClickChangeLanguage: PropTypes.func,
    onClickConfigureDevice: PropTypes.func,
    onClickLogout: PropTypes.func,
    onClickNavigateLog: PropTypes.func,
    onClickNavigateReports: PropTypes.func,
    onClickNavigateOperationsHub: PropTypes.func,
    open: PropTypes.bool,
    t: PropTypes.func.isRequired,
    username: PropTypes.string,
}

Menu.defaultProps = {
    app: null,
    hideLogout: false,
    onBlur: () => null,
    onClickChangeLanguage: () => null,
    onClickConfigureDevice: () => null,
    onClickLogout: () => null,
    onClickNavigateLog: () => null,
    onClickNavigateReports: () => null,
    onClickNavigateOperationsHub: () => null,
    open: false,
    username: null,
}

const mapStateToProps = ({ app }) => ({
    app,
})

export default connect(mapStateToProps)(withTranslation()(Menu))
